import type { FilterField, FilterLineType } from '../../../../components/new-design/vyTableFilter';
import { RevenueReportToolbar } from '../../reports-components/RevenueReportToolbar';

type BillingForecastReportToolbarProps = {
  onSearchChange: (value: string) => void;
  searchValue?: string;
  fromDate: Date | null;
  onFromDateChange: (date: Date | null) => void;
  toDate: Date | null;
  onToDateChange: (date: Date | null) => void;
  filterFields: FilterField[];
  filters: FilterLineType[];
  onFiltersChange: (filters: FilterLineType[]) => void;
  onExport: () => void;
  isRefreshing: boolean;
  onRefresh: () => void;
};

export const BillingForecastReportToolbar: React.FC<BillingForecastReportToolbarProps> = ({
  onSearchChange,
  searchValue,
  fromDate,
  onFromDateChange,
  toDate,
  onToDateChange,
  filterFields,
  filters,
  onFiltersChange,
  onExport,
  isRefreshing,
  onRefresh,
}) => (
  <RevenueReportToolbar
    onSearchChange={onSearchChange}
    searchValue={searchValue}
    searchPlaceholder="Search by Name"
    fromDate={fromDate}
    onFromDateChange={onFromDateChange}
    toDate={toDate}
    onToDateChange={onToDateChange}
    useDateRangePicker
    filterFields={filterFields}
    filters={filters}
    onFiltersChange={onFiltersChange}
    hideChartToggle
    onExport={onExport}
    onRefresh={onRefresh}
    isRefreshing={isRefreshing}
  />
);
